import axiosInstance from "../API/axiosInstance";


export const login = async (credentials) => {
    const { data } = await axiosInstance.post("/login", credentials);
    return data;
};

export const verifyOtp = async (payload) => {
    const { data } = await axiosInstance.post("/verifyotp", payload);
    return data;
};

export const guestLogin = async () => {
    const { data } = await axiosInstance.post("/guest-login");
    return data;
};

export const register = async (payload) => {
    const { data } = await axiosInstance.post("/register", payload);
    return data;
};

export const getCountries = async () => {
    const { data } = await axiosInstance.get("/location/countries");
    return data;
};

export const getCountryCodes = async () => {
    const { data } = await axiosInstance.get("/countries");
    return data;
};

export const getProfile = async () => {
    const { data } = await axiosInstance.get("/myprofile");
    return data;
};

export const updateProfile = async (payload) => {
    const { data } = await axiosInstance.put("/updateprofile", payload);
    return data;
};

export const getAllUsers = async () => {
    const { data } = await axiosInstance.get("/all-users");
    return data;
};

export const getUserById = async (userId) => {
    const { data } = await axiosInstance.get(`/user-by-id/${userId}`);
    return data;
};

export const getChapters = async (isoCode) => {
    const { data } = await axiosInstance.get(`/all-chapter-names`);
    return data;
};

export const getInterests = async () => {
    const { data } = await axiosInstance.get("/interests");
    return data;
};